import { Component, Input, OnInit } from '@angular/core';
import { faSearchengin } from '@fortawesome/free-brands-svg-icons';
import { IconDefinition, faWaveform } from '@fortawesome/pro-solid-svg-icons';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { SliderEnum } from 'src/app/components/utility/searchbar/searchbar/Enum/sliderEnum';
// tslint:disable: max-line-length
import {
   ClearAndStartLoadingDirectoryValues,
   DirectoryBrowserChangeMatchingPercentage,
} from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-browser-behaviour/directory-browser-behaviour.actions';
// tslint:enable: max-line-length
import { DirectoryBrowserBehaviourState } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-browser-behaviour/directory-browser-behaviour.state';

@Component({
   selector: 'samweb-phonetic-slider',
   templateUrl: './phonetic-slider.component.html',
   styleUrls: ['./phonetic-slider.component.scss'],
})
export class PhoneticSliderComponent implements OnInit {
   @Input()
   public brickInstanceId: string;
   public step$: Observable<number>;
   public strictIcon: IconDefinition = faSearchengin;
   public phoneticIcon: IconDefinition = faWaveform;

   public sliderEnum: SliderEnum[] = SliderEnum.getValues();
   public isMouseOverComponent: boolean;

   constructor(public store: Store) {}

   ngOnInit(): void {
      this.step$ = this.store.select(DirectoryBrowserBehaviourState.getDirectoryMatchingPercentage).pipe(
         map((getPercentage) => getPercentage(this.brickInstanceId)),
         distinctUntilChanged(),
         map((perc) => this.sliderEnum.find((x) => x.percent === perc).value)
      );
   }

   public onChange(value: number): void {
      this.store.dispatch(new DirectoryBrowserChangeMatchingPercentage(this.brickInstanceId, this.sliderEnum[value].percent));
      this.store.dispatch(new ClearAndStartLoadingDirectoryValues(this.brickInstanceId));
   }

   public togglePhoneticSearch(value: number) {
      if (value) {
         this.store.dispatch(new DirectoryBrowserChangeMatchingPercentage(this.brickInstanceId, this.sliderEnum[0].percent));
      } else {
         this.store.dispatch(new DirectoryBrowserChangeMatchingPercentage(this.brickInstanceId, this.sliderEnum[1].percent));
      }
      this.store.dispatch(new ClearAndStartLoadingDirectoryValues(this.brickInstanceId));
   }
}
